import DialogRoot from './DialogRoot'

export default DialogRoot
